import React, { Component, useEffect, useState } from "react";
import Form from "../../../comman/form";
import config from "../../../config.json";
import { Link } from "react-router-dom";
import Joi from "joi-browser";
import Swal from "sweetalert2";
import useForm from "../../../app/hooks/useForm";
import useControls from "../../../app/hooks/useControls";
import { candidateUpdated, getCandidateUpatedStatus, updateNewCandidate } from "../../../app/store/candidate";
import { useDispatch, useSelector } from "react-redux";
import { getAlert } from "../../../services/appAlerts";
import { getApplicationData } from "../../../app/store/application";
import { getStateAdminData } from "../../../app/store/duration";

const Msp = (props) => {

  const { candidateObj, updateSelectedObject, setSelectedTabKey,
    actType, setSelectedCandidateId, handleNextTab } = props;

  const stateAdminDataObj = useSelector(getStateAdminData)

  const mspMode = [
    { id: 101, name: "Not Applicable" },
    { id: 1, name: "Direct" },
    { id: 2, name: "MSP-DotStaff" },
    { id: 3, name: "MSP-ACRO" },
    { id: 4, name: "MSP-CAI" },
    { id: 5, name: "MSP-TAFFIN" },
    { id: 6, name: "Others" },
  ];

  const schema = {
    Msp_Mode: Joi.string().required().label("MSP Mode"),
  };

  const schema1 = {
    Msp_Contact1_Name: Joi.string().required().label("Name"),
    Msp_Contact1_Email: Joi.string()
      .email()
      .required()
      .label("Email Address")
      .allow(""),
    Msp_Contact1_Phone: Joi.string()
      .required()
      .length(10)
      .options({
        language: {
          string: {
            length: "Phone number must be 10 digits.",
          },
        },
      })
      .label("Phone Number"),
    Msp_Contact2_Name: Joi.string().required().label("Name"),
    Msp_Contact2_Email: Joi.string().email().required().label("Email Address"),
    Msp_Contact2_Phone: Joi.string()
      .required()
      .length(10)
      .options({
        language: {
          string: {
            length: "Phone number must be 10 digits.",
          },
        },
      })
      .label("Phone Number"),
  };

  const [aworkfinityApp, setAworkfinityApp] = useState(null);
  const [compName, setCompName] = useState("");
  const [agencyStateData, setAgencyStateData] = useState("");

  const candidateUpatedStatusSelector = useSelector(getCandidateUpatedStatus)

  const dispatch = useDispatch();

  useEffect(() => {
    if (candidateObj?.performerData) {
      const obj = getApplicationData(candidateObj.performerData);
      if (obj?.aWorkfinityApp) {
        setAworkfinityApp(obj.aWorkfinityApp);
        const appName = Object.keys(obj.aWorkfinityApp)[1];
        const aWorkfinityAppEntity = obj.aWorkfinityApp[appName];
        const mspData = aWorkfinityAppEntity["candidateonboardingform"];
        const data = {};
        if (mspData) {
          Object.keys(mspData).forEach(function (keyValue1) {
            if (keyValue1 !== "EntityId") {
              var item = mspData[keyValue1];
              if (!Array.isArray(item)) data[keyValue1.replace("@", "")] = item;
            }
          });
          setStateData(data);
        }
      }
    }
    else {
      setStateData({});
      setAworkfinityApp(null);
    }

  }, [candidateObj]);

  useEffect(() => {
    if (candidateObj?.performerData) {
      const obj = getApplicationData(candidateObj.performerData);
      if (obj?.aWorkfinityApp) {
        // setAworkfinityApp(obj.aWorkfinityApp);
        const appName = Object.keys(obj.aWorkfinityApp)[1];
        const aWorkfinityAppEntity = obj.aWorkfinityApp[appName];
        const agencyData = aWorkfinityAppEntity["projectengagement"];
        const data = {};
        if (agencyData) {
          Object.keys(agencyData).forEach(function (keyValue1) {
            if (keyValue1 !== "EntityId") {
              var item = agencyData[keyValue1];
              if (!Array.isArray(item)) data[keyValue1.replace("@", "")] = item;
            }
          });
          setAgencyStateData(data);
          // setUpdatedStateData(data);
        }
      }
    }
    // else {
    //   setStateData({});
    //   setAworkfinityApp(null);
    // }

  }, [candidateObj]);

  const doSubmit = () => {
    if (!candidateObj?.performerid) {
      getAlert("", "Save candidate details before updating MSP details", "warning");
      return;
    }

    if (stateData?.Msp_Mode === "Others" && !stateData?.MSP_Other_Mode) {
      getAlert("", "Please enter MSP Other Detail", "warning");
      return;
    }

    const NewAWorkfinityApp = { ...aworkfinityApp };
    const appName = Object.keys(NewAWorkfinityApp)[1];
    const aWorkfinityAppEntity = NewAWorkfinityApp[appName];
    const mspData = aWorkfinityAppEntity["candidateonboardingform"];
    Object.keys(stateData).forEach(function (keyValue) {
      mspData["@" + keyValue] = stateData[keyValue];
    });

    aWorkfinityAppEntity["candidateonboardingform"] = mspData;
    NewAWorkfinityApp[appName] = aWorkfinityAppEntity;
    setAworkfinityApp(NewAWorkfinityApp);
    const formData = new FormData();
    formData.append("appEntity", JSON.stringify(NewAWorkfinityApp));
    formData.append("recruiter", "");
    formData.append("subcontractor", "");
    formData.append("perfId", candidateObj.performerid);
    dispatch(updateNewCandidate(formData));
    setCompName("msp");
  }

  useEffect(() => {
    if (candidateUpatedStatusSelector && compName === "msp") {
      setCompName("");
      if (actType === "edit") {
        getAlert("", "Updated Successfully", "success");
      }
      else {
        getAlert("", "Added Successfully", "success");
      }

      updateSelectedObject(candidateObj.performerid, aworkfinityApp, "msp");

      dispatch(candidateUpdated(null));

      //setSelectedTabKey("home");
      //setSelectedCandidateId(0);

    }
  }, [candidateUpatedStatusSelector]);

  // const handleStateAdminOtherChange = (e) => {
  //   const { name, value } = e.target;
  //   setStateData((prev) => {
  //     const updatedState = { ...prev, [name]: value };
  //     console.log("updatedState", updatedState)
  //     const RatePayableIpcs = parseFloat(agencyStateData["RatePayableIpcs"]) || 0;
  //     const StateAdminFee = parseFloat(agencyStateData["State_Admin_Fee"]) || 0;
  //     const StateAdminFeeAmount = parseFloat(agencyStateData["State_Admin_Fee_Amount"]) || 0;
  //     const MspTechFee = parseFloat(updatedState.Msp_TechFee) || 0;
  //     const MspAdminFee = parseFloat(updatedState.Msp_AdminFee) || 0;
  //     const HubFee = parseFloat(updatedState.Hub_CompanyFee) || 0;

  //     let remainingRatePayable = RatePayableIpcs;

  //     if (StateAdminFee > 0) {
  //       const totalPercentage = StateAdminFee + MspAdminFee + HubFee;
  //       if (totalPercentage >= 100) {
  //         getAlert("Warning", `Invalid input: The total deductions exceed Rate Payable Ipcs`, "warning");
  //         return 
  //       }
  //       remainingRatePayable -= (totalPercentage / 100) * RatePayableIpcs;
  //     } else if (StateAdminFeeAmount > 0) {

  //       remainingRatePayable -= StateAdminFeeAmount;

  //       remainingRatePayable -= ((MspAdminFee + HubFee) / 100) * RatePayableIpcs;
  //     }

  //     remainingRatePayable -= MspTechFee;

  //     if (remainingRatePayable <= 0) {
  //       getAlert("Warning", `Invalid input: The total deductions exceed Rate Payable Ipcs`, "warning");
  //       return prev;
  //     }

  //     return updatedState;

  //   })
  // }
  const handleStateAdminOtherChange = (e) => {
    const { name, value } = e.target;

    // First, perform all validations before updating state
    const numericValue = parseFloat(value) || 0;

    // Create a temporary object with the potential new value
    const potentialNewState = { ...stateData, [name]: value };

    const RatePayableIpcs = parseFloat(agencyStateData["RatePayableIpcs"]) || 0;
    const StateAdminFee = parseFloat(agencyStateData["State_Admin_Fee"]) || 0;
    const StateAdminFeeAmount = parseFloat(agencyStateData["State_Admin_Fee_Amount"]) || 0;
    const MspTechFee = parseFloat(potentialNewState.Msp_TechFee) || 0;
    const MspAdminFee = parseFloat(potentialNewState.Msp_AdminFee) || 0;
    const HubFee = parseFloat(potentialNewState.Hub_CompanyFee) || 0;

    let remainingRatePayable = RatePayableIpcs;

    if (StateAdminFee > 0) {
      const totalPercentage = StateAdminFee + MspAdminFee + HubFee;
      if (totalPercentage >= 100) {
        getAlert("Warning", `Invalid input: The total deductions exceed Rate Payable Ipcs`, "warning");
        // Reset the input field value to previous state value
        e.target.value = stateData[name] || '';
        return;
      }
      remainingRatePayable -= (totalPercentage / 100) * RatePayableIpcs;
    } else if (StateAdminFeeAmount > 0) {
      remainingRatePayable -= StateAdminFeeAmount;
      remainingRatePayable -= ((MspAdminFee + HubFee) / 100) * RatePayableIpcs;
    }

    remainingRatePayable -= MspTechFee;

    if (remainingRatePayable <= 0) {
      getAlert("Warning", `Invalid input: The total deductions exceed Rate Payable Ipcs`, "warning");
      // Reset the input field value to previous state value
      e.target.value = stateData[name] || '';
      return;
    }

    // Only update state if validation passes
    setStateData(potentialNewState);
  }

  const { validate, handleChange, stateData, setStateData,
    stateErrors, setStateErrors, handleSubmit } = useForm(schema, doSubmit);

  const { renderSelect, renderInput, renderTextArea } = useControls(stateData, stateErrors, handleChange, schema);

  return (
    <div className="wf-msp-tab-container col-md-12">
      <style>{`
        /* Premium custom styles for MSP Tab matching AddWorkflowPerformer */
        .wf-msp-tab-container .form-group label {
          font-size: 11px !important; font-weight: 700 !important; color: #64748b !important;
          text-transform: uppercase !important; letter-spacing: 0.7px !important;
          margin-bottom: 6px !important; display: flex !important;
          align-items: center !important; gap: 5px !important;
        }

        .wf-msp-tab-container .form-group { margin-bottom: 16px; }
        .wf-msp-tab-container .wf-input-wrap { position: relative; }
        .wf-msp-tab-container .wf-input-icon {
          position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
          color: #94a3b8; font-size: 13px; pointer-events: none;
          transition: color 0.2s ease; z-index: 1;
        }
        .wf-msp-tab-container .wf-input-wrap:focus-within .wf-input-icon { color: #2563eb; }

        .wf-msp-tab-container .form-control {
          border-radius: 9px !important;
          border: 1.5px solid #e2e8f0 !important;
          padding: 8px 13px !important;
          font-size: 13px !important;
          color: #1e293b !important;
          background: #ffffff !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03) !important;
          width: 100% !important;
          height: auto !important;
        }
        .wf-msp-tab-container .form-control.wf-input-withicon {
          padding-left: 35px !important;
        }
        .wf-msp-tab-container .form-control:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1), 0 2px 6px -1px rgba(37, 99, 235, 0.08) !important;
          outline: none !important; background: #fafbff !important;
        }
        .wf-msp-tab-container select.form-control {
          appearance: none !important; -webkit-appearance: none !important;
          background: #ffffff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E") no-repeat right 12px center !important;
          padding-right: 32px !important;
        }

        .wf-msp-tab-container .btn-primary-custom {
          background: #2563eb !important;
          border: 1px solid #2563eb !important;
          color: #ffffff !important;
          font-weight: 700 !important;
          font-size: 13.5px !important;
          padding: 8px 24px !important;
          border-radius: 8px !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.12), 0 2px 4px -1px rgba(37, 99, 235, 0.06) !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
        }
        .wf-msp-tab-container .btn-primary-custom:hover:not(:disabled) {
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.18), 0 4px 6px -2px rgba(37, 99, 235, 0.08) !important;
        }
        .wf-msp-tab-container .btn-primary-custom:disabled {
          background: #e2e8f0 !important;
          border-color: #cbd5e1 !important;
          color: #94a3b8 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
        }

        .wf-msp-tab-container .wf-section-title {
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #1e293b !important;
          padding: 8px 12px !important;
          background: #f1f5f9 !important;
          border-left: 4px solid #2563eb !important;
          border-radius: 0 6px 6px 0 !important;
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          width: 100% !important;
          margin-top: 15px !important;
          margin-bottom: 15px !important;
        }
      `}</style>

      <div className="row">
        <div className="col-md-12">
          <h5 className="wf-section-title">
            <i className="fa fa-shield" /> MSP & Administrative Configuration
          </h5>
        </div>
        <div className="col-md-12">
          {renderSelect("Msp_Mode", "MSP Mode", mspMode, "name", "name", "fa-cog")}
        </div>

        <div className={`${stateData?.Msp_Mode === "Others" ? "col-md-6" : "col-md-12"} mb-3`}>
          {renderInput("Msp_AdminFee", "MSP Admin Fee %", "number", null, false, 0, undefined, "fa-percent")}
        </div>

        {
          stateData?.Msp_Mode === "Others" &&
          <div className="col-md-6">
            {renderInput("MSP_Other_Mode", "MSP Other Detail", "text", null, false, 0, undefined, "fa-info-circle")}
          </div>
        }

        <div className="col-md-12">
          <h5 className="wf-section-title">
            <i className="fa fa-user-circle-o" /> MSP Primary Contact
          </h5>
        </div>
        <div className="col-md-4">
          {renderInput("Msp_Contact1_Name", "Name", "text", null, false, 0, undefined, "fa-user")}
        </div>
        <div className="col-md-4">
          {renderInput("Msp_Contact1_Email", "Email", "text", null, false, 0, undefined, "fa-envelope-o")}
        </div>
        <div className="col-md-4">
          {renderInput("Msp_Contact1_Phone", "Phone No.", "phone", null, false, 0, undefined, "fa-phone")}
        </div>

        <div className="col-md-12">
          <h5 className="wf-section-title">
            <i className="fa fa-user-circle-o" /> MSP Secondary Contact
          </h5>
        </div>
        <div className="col-md-4">
          {renderInput("Msp_Contact2_Name", "Name", "text", null, false, 0, undefined, "fa-user")}
        </div>
        <div className="col-md-4">
          {renderInput("Msp_Contact2_Email", "Email", "text", null, false, 0, undefined, "fa-envelope-o")}
        </div>
        <div className="col-md-4">
          {renderInput("Msp_Contact2_Phone", "Phone No.", "phone", null, false, 0, undefined, "fa-phone")}
        </div>

        <div className="col-md-12">
          <h5 className="wf-section-title">
            <i className="fa fa-sticky-note-o" /> Engagement Notes
          </h5>
        </div>
        <div className="col-md-12">
          {renderTextArea("mspNotes", "Notes", "fa-file-text-o")}
        </div>

        <div className="col-md-12">
          <h5 className="wf-section-title">
            <i className="fa fa-cogs" /> Other Fee Details
          </h5>
        </div>

        <div className="col-md-6 mb-3">
          {renderInput("Hub_CompanyFee", "HUB Fee %", "number", null, false, 0, undefined, "fa-percent")}
        </div>

        <div className="col-md-12 text-center form-group mt-4 mb-4">
          <button
            type="button"
            className="btn-primary-custom"
            disabled={validate()}
            onClick={handleSubmit}
          >
            <i className="fa fa-check" /> Save and Complete MSP Configuration
          </button>
          {actType !== "edit" && (
            <button
              type="button"
              className="btn-primary-custom ml-2"
              onClick={() => handleNextTab("exit")}
            >
              <i className="fa fa-arrow-left" /> Back to Candidates
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Msp;
